import Vue from "vue";
const Vuex = require("vuex");
import createPersistedState from "vuex-persistedstate";

import { _ } from "vue-underscore";
import jwtDecode from "jwt-decode";
import StoreConstants from "./services/StoreConstants";
import ExternalRestService from "../services/rest/services/ExternalRestService";
import Constants from "../services/Constants";
import CourseRelationshipRestService from "../services/rest/services/CourseRelationshipRestService";
import moment from "moment";
import Utilities from "../services/Utilities";
import AccountRestService from "../services/rest/services/AccountRestService";
import CourseRestService from "../services/rest/services/CourseRestService";
import ExamRestService from "../services/rest/services/ExamRestService";

Vue.use(Vuex);

const getDefaultState = () => {
  return {
    session: null,
    token: {},
    courses: [],
    viewConfigs: {}
  };
};

const state = getDefaultState();

export default new Vuex.Store({
  plugins: [createPersistedState()],
  state,
  actions: {
    [StoreConstants.ACTIONS.SIGN_OUT]({ commit }) {
      commit("resetState");
    },
    async logIn({ commit, dispatch, getters }, payload) {
      try {
        let res = await ExternalRestService.login(payload);
        let token = (res.data || {}).token || "";
        commit("setToken", token);
      } catch (error) {
        console.log(error);
        return true;
      }

      try {
        let results = await Promise.all([
          CourseRelationshipRestService.getCourseRelationshipsForUser(
            getters[StoreConstants.GETTERS.USER]
          ),
          CourseRestService.getCourseIds(),
          dispatch(StoreConstants.ACTIONS.SET_USER_EMAILS)
        ]);

        let courseRelationships = results[0].data;
        for (let i = 0; i < courseRelationships.length; i++) {
          courseRelationships[i].color =
            Constants.COURSE_COLORS[i] || "#191919";
        }
        commit("setCourses", courseRelationships);
        commit("setCourseNames", results[1].data);
      } catch (error) {
        console.log(error);
      }
    },
    [StoreConstants.ACTIONS.SET_TOKEN]({ commit }, payload) {
      commit("setToken", payload);
    },

    async [StoreConstants.ACTIONS.SET_USER_EMAILS]({ commit, getters }) {
      if (getters[StoreConstants.GETTERS.USER_EMAILS]) return;

      if (!getters[StoreConstants.GETTERS.IS_ADMIN]) return;

      try {
        let users = await AccountRestService.getUserEmails();
        commit("setUserEmails", users.data);
      } catch (e) {
        console.log(e);
      }
    },

    async [StoreConstants.ACTIONS.SUBMIT_EXAM]({ commit }, payload) {
      console.log(payload);

      try {
        let response = await ExamRestService.submitExam(payload);
        commit("addScoreReport", {
          relationshipId: payload._id,
          scoreReport: response.data
        });
        return response.data;
      } catch (error) {
        console.log(error);
      }
    },

    [StoreConstants.ACTIONS.DELETE_SCORE_REPORT]({ commit }, payload) {
      commit("deleteScoreReport", payload);
    }
  },
  mutations: {
    resetState(state) {
      Object.assign(state, getDefaultState());
    },

    setToken(state, token) {
      state.session = token;
      state.token = jwtDecode(token);
    },

    setCourses(state, courses) {
      state.courses = courses;
    },

    setCourseNames(state, courseNames) {
      Vue.set(state.viewConfigs, "courseNames", courseNames);
    },

    setUserEmails(state, users) {
      Vue.set(state.viewConfigs, "userEmails", users);
    },

    addScoreReport(state, payload) {
      let relationshipId = payload.relationshipId,
        scoreReport = payload.scoreReport,
        course = state.courses.find(course => course._id === relationshipId);

      course.scoreReports.push(scoreReport);
    },

    deleteScoreReport(state, payload) {
      let relationshipId = payload.relationshipId,
        reportId = payload.reportId;

      let courseRelationship = _.findWhere(state.courses, {
          _id: relationshipId
        }),
        reportIndex = _.findIndex(courseRelationship.scoreReports, {
          _id: reportId
        });

      courseRelationship.scoreReports.splice(reportIndex, 1);
    }
  },
  getters: {
    [StoreConstants.GETTERS.ACCESS](state) {
      return state.token.access || "";
    },
    [StoreConstants.GETTERS.COURSE]: state => _id => {
      return state.courses.find(course => course._id === _id);
    },
    [StoreConstants.GETTERS.COURSES](state) {
      return state.courses;
    },
    [StoreConstants.GETTERS.COURSE_OBJECTS](state) {
      let courseObjects = state.courses.map(course => course.course);
      return Utilities.distinctObjects(courseObjects, "_id");
    },
    [StoreConstants.GETTERS.COURSE_NAMES](state) {
      return state.viewConfigs.courseNames;
    },
    [StoreConstants.GETTERS.IS_LOGGED_IN](state) {
      return state.session;
    },
    [StoreConstants.GETTERS.IS_ADMIN](state) {
      return state.token.access === Constants.ACCESS_TYPES.ADMIN;
    },
    [StoreConstants.GETTERS.IS_STAFF](state) {
      return (
        state.token.access === Constants.ACCESS_TYPES.ADMIN ||
        state.token.access === Constants.ACCESS_TYPES.TUTOR
      );
    },
    [StoreConstants.GETTERS.IS_STUDENT](state) {
      return state.token.access === Constants.ACCESS_TYPES.STUDENT;
    },
    [StoreConstants.GETTERS.USER](state) {
      return state.token.email;
    },
    [StoreConstants.GETTERS.USER_EMAILS](state) {
      return state.viewConfigs.userEmails;
    },
    [StoreConstants.GETTERS.IS_SESSION_REPORT_DUE]: state => _id => {
      let course = state.courses.find(course => course._id === _id);

      if (!course.nextSessionDate) return false;

      let nextSesionTime = course.nextSessionEndTime
          ? course.nextSessionEndTime
          : "23:59",
        dueDate = moment(`${course.nextSessionDate} ${nextSesionTime}`);

      return moment().isAfter(dueDate);
    }
  }
});
